<template>
  <div>
    <Head title="Data Pertanggung Jawaban" />
    <h1 class="mb-6 text-xl font-bold sm:text-2xl">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/accountability-reports">
        Pertanggung Jawaban
      </Link>
      <span class="font-medium text-indigo-400"> /</span>
      Rencana Anggaran
    </h1>

    <!-- INFORMASI PERTANGGUNG JAWABAN (border + responsive) -->
    <div class="w-full mb-8 bg-white border border-gray-300 rounded-md shadow">
      <div class="flex flex-col justify-between gap-4 px-4 py-4 text-sm bg-gray-100 sm:flex-row sm:items-center sm:px-6 sm:py-5">
        <h2 class="text-lg font-semibold sm:text-xl">Informasi Pertanggung Jawaban</h2>

        <!-- Tombol -->
        <div class="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:gap-4">
          <Button
            v-if="can('write permohonan beasiswa') && (application.status == 0 || application.status == 2 || application.status == 6) && isValid && !isAnggaranOver"
            type="button"
            class="w-full sm:w-auto btn-green"
            @click.prevent="kirim"
          >
            <span><font-awesome-icon icon="fas fa-paper-plane" class="mr-2" />Simpan Rencana Anggaran</span>
          </Button>

          <Link
            v-else-if="isValid && !isAnggaranOver"
            title="Laporan"
            class="w-full rounded sm:w-auto btn-red-sm"
            :href="`/accountability-reports/${application.id}/document`"
          >
            <font-awesome-icon icon="fas fa-file-contract" /> Upload Dokumen Laporan
          </Link>

          <div
            v-else
            class="w-full text-sm text-red-700 sm:w-auto"
            title="Tambahkan Biaya Pendidikan atau pastikan total anggaran tidak melebihi batas"
            disabled
          >
            <font-awesome-icon icon="fas fa-file-contract" />
            Tambahkan Biaya Pendidikan atau pastikan total anggaran tidak melebihi batas
          </div>
        </div>
      </div>

      <!-- Info: desktop-table & mobile-cards -->
      <!-- DESKTOP -->
      <div class="hidden p-4 sm:block sm:p-6">
        <table class="w-full text-sm border border-gray-300 rounded-md">
          <tbody>
            <tr class="border-b">
              <td class="w-1/4 p-2 font-semibold bg-gray-50">NIM Pemohon</td>
              <td class="w-1/4 p-2">: {{ application.nim }}</td>
              <td class="w-1/4 p-2 font-semibold bg-gray-50">Jenis Beasiswa</td>
              <td class="w-1/4 p-2">: {{ application.jenis }}</td>
            </tr>
            <tr class="border-b">
              <td class="p-2 font-semibold bg-gray-50">Nama Pemohon</td>
              <td class="p-2">: {{ application.nama_pemohon }}</td>
              <td class="p-2 font-semibold bg-gray-50">Maksimal Beasiswa</td>
              <td class="p-2">: {{ formatCurrency(application.nominal) }}</td>
            </tr>
            <tr class="border-b">
              <td class="p-2 font-semibold bg-gray-50">Nama Universitas</td>
              <td class="p-2">: {{ application.nama_universitas }}</td>
              <td class="p-2 font-semibold bg-gray-50">Semester</td>
              <td class="p-2">: {{ application.semester }}</td>
            </tr>
            <tr class="border-b">
              <td class="p-2 font-semibold bg-gray-50">Program Studi</td>
              <td class="p-2">: {{ application.nama_prodi }}</td>
              <td class="p-2 font-semibold bg-gray-50">Nilai IPK</td>
              <td class="p-2">: {{ application.ipk }}</td>
            </tr>
            <tr>
              <td class="p-2 font-semibold bg-gray-50">No Rekening</td>
              <td class="p-2">: {{ application.account_number }}</td>
              <td class="p-2 bg-gray-50" />
              <td class="p-2" />
            </tr>
          </tbody>
        </table>
      </div>

      <!-- MOBILE -->
      <div class="grid grid-cols-1 gap-2 p-4 text-sm sm:hidden">
        <div class="border border-gray-200 rounded-md">
          <div class="flex justify-between px-3 py-2 font-semibold border-b bg-gray-50">
            <span>NIM Pemohon</span><span>{{ application.nim }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Nama Pemohon</span><span class="text-right">{{ application.nama_pemohon }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Nama Universitas</span><span class="text-right">{{ application.nama_universitas }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Program Studi</span><span class="text-right">{{ application.nama_prodi }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Jenis Beasiswa</span><span class="text-right">{{ application.jenis }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Maksimal Beasiswa</span><span class="text-right">{{ formatCurrency(application.nominal) }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Semester</span><span>{{ application.semester }}</span>
          </div>
          <div class="flex justify-between px-3 py-2 border-b">
            <span>Nilai IPK</span><span>{{ application.ipk }}</span>
          </div>
          <div class="flex justify-between px-3 py-2">
            <span>No Rekening</span><span class="text-right">{{ application.account_number }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- FORM CREATE -->
    <div v-if="!(application.status == 2 || application.status == 5 || application.status == 7)" class="w-full bg-white border border-gray-300 rounded-md shadow">
      <div class="px-4 py-3 text-lg font-semibold bg-gray-100 sm:px-6 sm:py-4">
        Tambah Rencana Anggaran
      </div>
      <form class="p-4 sm:p-8" @submit.prevent="uploadDetail">
        <div class="flex flex-wrap -mx-3">
          <div class="w-full px-3 mb-4 sm:mb-6 sm:w-1/3">
            <label class="form-label">Jenis Penggunaan</label>
            <v-select v-model="formAnggaran.category" :options="categories" placeholder="Pilih Jenis" />
            <div v-if="formAnggaran.errors.category" class="form-error">{{ formAnggaran.errors.category }}</div>
          </div>

          <div v-if="descriptions.length > 1" class="w-full px-3 mb-4 sm:mb-6 sm:w-1/3">
            <label class="form-label">Uraian Biaya</label>
            <v-select v-model="formAnggaran.description" :options="descriptions" placeholder="Pilih Uraian" />
            <div v-if="formAnggaran.errors.description" class="form-error">{{ formAnggaran.errors.description }}</div>
          </div>
          <div v-else class="w-full px-3 mb-4 sm:mb-6 sm:w-1/3">
            <label class="form-label">Uraian Biaya</label>
            <input type="text" class="form-input" :value="descriptions[0]" disabled />
          </div>

          <text-input
            v-model="formattedNominal"
            type="text"
            :error="formAnggaran.errors.nominal_rab"
            class="w-full px-3 mb-4 sm:mb-6 sm:w-1/3"
            label="Nominal"
          />
        </div>

        <div class="flex flex-col justify-end gap-3 px-4 py-3 mt-4 border-t border-gray-100 sm:flex-row sm:items-center bg-gray-50">
          <loading-button :loading="formAnggaran.processing" class="w-full sm:w-auto btn-green" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" /> Simpan
          </loading-button>
        </div>
      </form>
    </div>

    <!-- DAFTAR RENCANA ANGGARAN -->
    <div class="w-full mt-8 bg-white border border-gray-300 rounded-md shadow">
      <div class="px-4 py-3 text-lg font-semibold bg-gray-100 sm:px-6 sm:py-4">
        Daftar Rencana Anggaran
      </div>

      <!-- DESKTOP: tabel -->
      <div class="hidden overflow-x-auto sm:block">
        <table class="min-w-full text-sm whitespace-nowrap">
          <thead class="text-left text-gray-700 border-b">
            <tr>
              <th class="px-4 py-3">Jenis / Uraian</th>
              <th class="px-2 py-3 text-right">Nominal RAB</th>
              <th class="px-2 py-3 text-right">Nominal Disetujui</th>
              <th class="px-4 py-3 text-center">Status Verifikasi</th>
              <th v-if="can('write permohonan beasiswa')" class="px-4 py-3">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="detail in application.details"
              :key="detail.id"
              class="border-t hover:bg-gray-50"
            >
              <td class="p-3 pl-4">
                <p class="font-semibold">{{ detail.category }}</p>
                <p class="text-gray-600">{{ detail.description }}</p>
              </td>
              <td class="p-3 text-right">{{ formatCurrency(detail.nominal_rab) }}</td>
              <td class="p-3 text-right">{{ formatCurrency(detail.nominal_verifikasi) }}</td>
              <td class="p-3 text-center">
                <span v-if="detail.status == 0" class="px-3 py-1 text-xs font-medium text-yellow-900 bg-yellow-200 rounded">Draft</span>
                <span v-else-if="detail.status == 1" class="px-3 py-1 text-xs font-medium rounded">-</span>
                <span v-else-if="detail.status == 2" class="px-3 py-1 text-xs font-medium text-red-900 bg-red-200 rounded">Belum Memenuhi Syarat</span>
                <span v-else-if="detail.status == 3" class="px-3 py-1 text-xs font-medium text-white bg-red-500 rounded">Tidak Memenuhi Syarat</span>
                <span v-else-if="detail.status == 5" class="px-3 py-1 text-xs font-medium text-yellow-900 bg-yellow-200 rounded">Diajukan</span>
                <span v-else-if="detail.status == 6" class="px-3 py-1 text-xs font-medium text-yellow-900 bg-yellow-400 rounded">Revisi</span>
                <span v-else class="px-3 py-1 text-xs font-medium text-white bg-green-500 rounded">Disetujui</span>
                <p class="mt-1 text-xs text-gray-600">{{ detail.catatan_verifikasi }}</p>
              </td>
              <td v-if="can('write permohonan beasiswa')" class="p-3 text-center">
                <Button
                  v-if="detail.status == 0 || detail.status == 1 || detail.status == 2|| detail.status == 6"
                  type="button"
                  class="btn-red-sm"
                  title="Hapus"
                  @click.prevent="destroyDetail(detail.id)"
                >
                  <font-awesome-icon icon="fas fa-trash" />
                </Button>
              </td>
            </tr>
            <tr v-if="application.details.length === 0">
              <td class="px-4 py-3 text-center text-gray-600 border-t" :colspan="can('write permohonan beasiswa') ? 5 : 4">
                Tidak ada data penggunaan anggaran yang diupload.
              </td>
            </tr>
          </tbody>
          <tfoot class="font-semibold text-gray-800 bg-gray-100">
            <tr>
              <td class="px-4 py-3">Total Anggaran</td>
              <td class="px-2 py-3 text-right">{{ formatCurrency(totalAnggaran) }}</td>
              <td class="px-2 py-3 text-right">{{ formatCurrency(totalDisetujui) }}</td>
              <td class="px-4 py-3" :colspan="can('write permohonan beasiswa') ? 2 : 1" />
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- MOBILE: list card (tanpa scroll) -->
      <div class="p-3 space-y-3 sm:hidden">
        <div
          v-for="detail in application.details"
          :key="detail.id"
          class="border rounded-lg"
        >
          <div class="flex items-start justify-between gap-3 px-3 py-2 border-b rounded-t-lg bg-gray-50">
            <div>
              <p class="font-semibold leading-tight">{{ detail.category }}</p>
              <p class="text-xs text-gray-600">{{ detail.description }}</p>
            </div>
            <div class="text-right">
              <div class="text-xs text-gray-500">Nominal RAB</div>
              <div class="font-semibold">{{ formatCurrency(detail.nominal_rab) }}</div>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-2 px-3 py-2 text-sm">
            <div class="text-gray-500">Nominal Disetujui</div>
            <div class="font-medium text-right">{{ formatCurrency(detail.nominal_verifikasi) }}</div>

            <div class="text-gray-500">Status</div>
            <div class="text-right">
              <span v-if="detail.status == 0" class="px-2 py-0.5 text-xs font-medium text-yellow-900 bg-yellow-200 rounded">Draft</span>
              <span v-else-if="detail.status == 1" class="px-2 py-0.5 text-xs font-medium rounded">-</span>
              <span v-else-if="detail.status == 2" class="px-2 py-0.5 text-xs font-medium text-red-900 bg-red-200 rounded">Belum Memenuhi Syarat</span>
              <span v-else-if="detail.status == 3" class="px-2 py-0.5 text-xs font-medium text-white bg-red-500 rounded">Tidak Memenuhi Syarat</span>
              <span v-else-if="detail.status == 5" class="px-2 py-0.5 text-xs font-medium text-yellow-900 bg-yellow-200 rounded">Diajukan</span>
              <span v-else-if="detail.status == 6" class="px-2 py-0.5 text-xs font-medium text-yellow-900 bg-yellow-400 rounded">Revisi</span>
              <span v-else class="px-2 py-0.5 text-xs font-medium text-white bg-green-500 rounded">Disetujui</span>
            </div>

            <div v-if="detail.catatan_verifikasi" class="col-span-2">
              <div class="text-gray-500">Catatan</div>
              <div class="mt-0.5 text-[13px] leading-snug text-gray-700">{{ detail.catatan_verifikasi }}</div>
            </div>
          </div>

          <div v-if="can('write permohonan beasiswa')" class="flex justify-end px-3 py-2 border-t rounded-b-lg bg-gray-50">
            <Button
              v-if="detail.status == 0 || detail.status == 1 || detail.status == 2 || detail.status == 6"
              type="button"
              class="btn-red-sm"
              title="Hapus"
              @click.prevent="destroyDetail(detail.id)"
            >
              <font-awesome-icon icon="fas fa-trash" />
            </Button>
          </div>
        </div>

        <!-- Footer total (mobile) -->
        <div class="overflow-hidden border rounded-lg">
          <div class="flex items-center justify-between px-3 py-2 font-semibold bg-gray-100">
            <span>Total Anggaran</span>
            <span>{{ formatCurrency(totalAnggaran) }}</span>
          </div>
          <div class="flex items-center justify-between px-3 py-2">
            <span class="text-gray-700">Total Disetujui</span>
            <span class="font-semibold">{{ formatCurrency(totalDisetujui) }}</span>
          </div>
        </div>

        <!-- Empty state (mobile) -->
        <div v-if="application.details.length === 0" class="p-4 text-center text-gray-600 border rounded-lg">
          Tidak ada data penggunaan anggaran yang diupload.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: { Head, Link, LoadingButton, TextInput, FontAwesomeIcon },
  layout: Layout,
  props: { application: Object, expenseDescriptions: Array },
  remember: ['formAnggaran'],
  data() {
    return {
      categories: ['Biaya Pendidikan', 'Biaya Penunjang Lainnya'],
      formAnggaran: this.$inertia.form({
        accountability_report_id: this.application.id,
        category: null,
        description: null,
        nominal_rab: null,
      }),
    }
  },
  computed: {
    formattedNominal: {
      get() { return this.formatCurrency(this.formAnggaran.nominal_rab) },
      set(value) { this.formAnggaran.nominal_rab = Number(value.replace(/[^0-9]/g, '')) },
    },
    descriptions() {
      if (this.formAnggaran.category === 'Biaya Pendidikan') return ['UKT/SPP']
      if (this.formAnggaran.category === 'Biaya Penunjang Lainnya') return this.expenseDescriptions
      return []
    },
    hasBiayaPendidikan() {
      return this.application.details.some(d => d.category === 'Biaya Pendidikan')
    },
    isValid() {
      return this.application.details.some(d => d.category === 'Biaya Pendidikan')
    },
    totalAnggaran() {
      return this.application.details.reduce((s, d) => s + (Number(d.nominal_rab) || 0), 0)
    },
    totalDisetujui() {
      return this.application.details.reduce((s, d) => s + (Number(d.nominal_verifikasi) || 0), 0)
    },
    isAnggaranOver() {
      return this.totalAnggaran > this.application.nominal
    },
  },
  watch: {
    'formAnggaran.category'(v) {
      if (v === 'Biaya Pendidikan') this.formAnggaran.description = 'UKT/SPP'
      else if (v === 'Biaya Penunjang Lainnya') this.formAnggaran.description = 'Akomodasi'
      else this.formAnggaran.description = null
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return 'Rp 0'
      return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(value)
    },
    uploadDetail() {
      if (this.formAnggaran.category === 'Biaya Pendidikan' && this.hasBiayaPendidikan) {
        this.$swal.fire({ title: 'Tidak diizinkan', text: 'Biaya Pendidikan hanya boleh diisi sekali.', icon: 'warning' })
        return
      }
      this.formAnggaran.post('/accountability-report-details', { onSuccess: () => this.formAnggaran.reset() })
    },
    destroyDetail(id) {
      this.confirmAction('Anda yakin hapus data penggunaan anggaran ini?', 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!', () => {
        this.$inertia.delete(`/accountability-report-details/${id}`)
      })
    },
    kirim() {
      this.confirmAction('Anda yakin menyimpan Rencana Penggunaan Beasiswa ini?', 'Pastikan semua informasi yang anda kirimkan sudah sesuai!', () => {
        this.$inertia.put(`/accountability-reports/${this.application.id}/send`)
      })
    },
    confirmAction(title, text, onConfirm) {
      this.$swal.fire({
        title, text, icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then(r => { if (r.isConfirmed) onConfirm() })
    },
  },
}
</script>

<style scoped>
.form-error { color: #b91c1c; font-size: 0.875rem; }
.form-valid { color: #15803d; }
</style>
